import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

const mc = (
    <FormattedMessage
        id="dc.bulkRequestSuccessModal.messageCenter"
        defaultMessage="Message Center"
    />
);

const mcLink = <Link href="/inbox/">{mc}</Link>;

export default mcLink;
